import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosApi } from "./axios";
import {
  CreateLogBoDto,
  GetLogsByEntityTypeParams,
  LogDto,
  LogResponseDto,
} from "../types/api/api-types";

export type LogEntry = LogDto;

const getLogsByEntity = (entityType: string, entityId: string) =>
  axiosApi.get<LogEntry[]>(`/log/entity/${entityType}/${entityId}`).then((r) => r.data);

const getLogsByEntityType = (entityType: string, params: GetLogsByEntityTypeParams) =>
  axiosApi.get<LogResponseDto>(`/log/type/${entityType}`, { params }).then((r) => r.data);

export const useGetLogsByEntity = (
  entityType: string,
  entityId: string,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: ["logs", "entity", entityType, entityId],
    queryFn: () => getLogsByEntity(entityType, entityId),
    enabled: options?.enabled ?? true,
  });

export const useGetLogsByEntityType = (
  entityType: string,
  params: GetLogsByEntityTypeParams,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: ["logs", "type", entityType, params],
    queryFn: () => getLogsByEntityType(entityType, params),
    enabled: options?.enabled ?? true,
  });

const createLogBo = (payload: CreateLogBoDto) =>
  axiosApi.post<Omit<LogEntry, "user">>("/log", payload).then((r) => r.data);

export const useCreateLogBo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createLogBo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["logs"] });
    },
  });
};
